import * as PIXI from "pixi.js";
import TopSwitcherRenderer from "./TopSwitcherRenderer";
import { Coord, TopSwitcherOptions, TopSwitcherProps } from "../../../types/Interface";


export default class TopSwitcher {
  private TopSwitcherRenderer!: TopSwitcherRenderer;

  constructor(private TopSwitcherProps: TopSwitcherProps, con?: PIXI.Container, options?: TopSwitcherOptions) {
    this.TopSwitcherRenderer = new TopSwitcherRenderer(this.TopSwitcherProps, con, options);
  }
  setCoord = (coord: Coord) => this.TopSwitcherRenderer.position.copyFrom(coord);
}